import { ApplicationState } from "../../applicationState";
import { ProductsListState } from "./state";

export const selectProductsListState = (state: ApplicationState): ProductsListState => state.productsList;

export const selectSearchString = (state: ApplicationState): string => state.productsList.searchString;
